import { render, staticRenderFns } from "./createdCustom.vue?vue&type=template&id=b35db2e2&scoped=true&"
import script from "./createdCustom.vue?vue&type=script&lang=js&"
export * from "./createdCustom.vue?vue&type=script&lang=js&"
import style0 from "./createdCustom.vue?vue&type=style&index=0&id=b35db2e2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35db2e2",
  null
  
)

export default component.exports